<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.accidentsCount.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">労災発生件数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>休業3日以内</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="accidentsCount.lessThanSuspensionThreeDays" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>休業4日以上</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="accidentsCount.moreThanSuspensionFourDays" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            労災発生件数
            <strong><Currency :value="this.calAchievementAccidentsCount"/></strong>件
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(accidentsCount.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(accidentsCount.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の労災発生件数データ
    accidentsCount: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '件',
    }
  },
  computed: {
    calAchievementAccidentsCount() {
      if ( !(this.accidentsCount.lessThanSuspensionThreeDays!=null && this.accidentsCount.moreThanSuspensionFourDays!=null) ) {
        return null;
      }else if ( String(this.accidentsCount.lessThanSuspensionThreeDays).length * String(this.accidentsCount.moreThanSuspensionFourDays).length == 0) {
        return null;
      }else if ( isNaN(this.accidentsCount.lessThanSuspensionThreeDays) || isNaN(this.accidentsCount.moreThanSuspensionFourDays)) {
        return null;
      }else{
        return Number(this.accidentsCount.lessThanSuspensionThreeDays) + Number(this.accidentsCount.moreThanSuspensionFourDays);
      }
    }
  },
  watch: {
    accidentsCount() {
      this.inputAccidentsCount();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputAccidentsCount() {
      this.$emit("change-accidents-count-detail", {
        accidentsCount: this.accidentsCount,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
